export default __webpack_public_path__ + "static/media/specialOffer.20f6d983.svg";